<template>
  <section class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <h4><i class="fas fa-file-alt"></i> Summary Lengkap Try Out</h4>
            <button class="btn btn-outline-secondary" @click="$router.go(-1)">
              <i class="fas fa-arrow-left"></i> Kembali
            </button>
          </div>
        </div>
      </div>

      <!-- Info Siswa -->
      <div class="card mb-4">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-auto" v-if="info.img_url">
              <img :src="info.img_url" class="img-circle elevation-2" style="width:80px;height:80px;object-fit:cover;">
            </div>
            <div class="col">
              <h4 class="mb-0">{{ info.nama_siswa || info.display_name }}</h4>
              <span class="text-muted">{{ info.kelas || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Overall Stats -->
      <div class="row mb-4">
        <div class="col-md-3 col-6 mb-2">
          <div class="info-box">
            <span class="info-box-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
              <i class="fas fa-list-ol"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Total Ujian</span>
              <span class="info-box-number">{{ overall.total_ujian }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-2">
          <div class="info-box">
            <span class="info-box-icon" style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); color: white;">
              <i class="fas fa-chart-line"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Rata-rata Skor</span>
              <span class="info-box-number">{{ overall.rata_rata }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-2">
          <div class="info-box">
            <span class="info-box-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: white;">
              <i class="fas fa-trophy"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Skor Tertinggi</span>
              <span class="info-box-number">{{ overall.skor_tertinggi }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-2">
          <div class="info-box">
            <span class="info-box-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: white;">
              <i class="fas fa-award"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Program Terbaik</span>
              <span class="info-box-number" style="font-size: 18px;">{{ overall.program_terbaik }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary per Tipe -->
      <div class="row">
        <!-- SKD -->
        <div class="col-lg-6 mb-4" v-if="summary.skd && summary.skd.total_ujian > 0">
          <div class="card card-outline card-primary h-100">
            <div class="card-header">
              <h5 class="card-title"><i class="fas fa-cubes text-primary"></i> SKD</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                <tr><td>Total Ujian</td><td class="text-right"><strong>{{ summary.skd.total_ujian }}</strong></td></tr>
                <tr><td>Rata-rata Skor</td><td class="text-right"><strong class="text-primary">{{ summary.skd.rata_rata }}</strong></td></tr>
                <tr><td>Skor Tertinggi</td><td class="text-right"><strong class="text-success">{{ summary.skd.skor_tertinggi }}</strong></td></tr>
                <tr><td>Skor Terendah</td><td class="text-right"><strong class="text-danger">{{ summary.skd.skor_terendah }}</strong></td></tr>
              </table>
              <div class="mt-2">
                <small class="text-muted">Detail Ujian:</small>
                <ul class="list-unstyled mt-1" style="max-height:150px;overflow-y:auto;">
                  <li v-for="u in summary.skd.list" :key="u.id" class="mb-1 d-flex justify-content-between">
                    <span class="badge badge-light">{{ u.tanggal }}</span>
                    <span :class="u.skor >= 70 ? 'text-success' : 'text-danger'"><strong>{{ u.skor }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Polri -->
        <div class="col-lg-6 mb-4" v-if="summary.polri && summary.polri.total_ujian > 0">
          <div class="card card-outline card-danger h-100">
            <div class="card-header">
              <h5 class="card-title"><i class="fas fa-shield-alt text-danger"></i> Polri</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                <tr><td>Total Ujian</td><td class="text-right"><strong>{{ summary.polri.total_ujian }}</strong></td></tr>
                <tr><td>Rata-rata Skor</td><td class="text-right"><strong class="text-primary">{{ summary.polri.rata_rata }}</strong></td></tr>
                <tr><td>Skor Tertinggi</td><td class="text-right"><strong class="text-success">{{ summary.polri.skor_tertinggi }}</strong></td></tr>
                <tr><td>Skor Terendah</td><td class="text-right"><strong class="text-danger">{{ summary.polri.skor_terendah }}</strong></td></tr>
              </table>
              <div class="mt-2">
                <small class="text-muted">Detail Ujian:</small>
                <ul class="list-unstyled mt-1" style="max-height:150px;overflow-y:auto;">
                  <li v-for="u in summary.polri.list" :key="u.id" class="mb-1 d-flex justify-content-between">
                    <span class="badge badge-light">{{ u.tanggal }}</span>
                    <span :class="u.skor >= 70 ? 'text-success' : 'text-danger'"><strong>{{ u.skor }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- TPA -->
        <div class="col-lg-6 mb-4" v-if="summary.tpa && summary.tpa.total_ujian > 0">
          <div class="card card-outline card-warning h-100">
            <div class="card-header">
              <h5 class="card-title"><i class="fas fa-brain text-warning"></i> TPA</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                <tr><td>Total Ujian</td><td class="text-right"><strong>{{ summary.tpa.total_ujian }}</strong></td></tr>
                <tr><td>Rata-rata Skor</td><td class="text-right"><strong class="text-primary">{{ summary.tpa.rata_rata }}</strong></td></tr>
                <tr><td>Skor Tertinggi</td><td class="text-right"><strong class="text-success">{{ summary.tpa.skor_tertinggi }}</strong></td></tr>
                <tr><td>Skor Terendah</td><td class="text-right"><strong class="text-danger">{{ summary.tpa.skor_terendah }}</strong></td></tr>
              </table>
              <div class="mt-2">
                <small class="text-muted">Detail Ujian:</small>
                <ul class="list-unstyled mt-1" style="max-height:150px;overflow-y:auto;">
                  <li v-for="u in summary.tpa.list" :key="u.id" class="mb-1 d-flex justify-content-between">
                    <span class="badge badge-light">{{ u.tanggal }}</span>
                    <span :class="u.skor >= 70 ? 'text-success' : 'text-danger'"><strong>{{ u.skor }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Sprint -->
        <div class="col-lg-6 mb-4" v-if="summary.sprint && summary.sprint.total_ujian > 0">
          <div class="card card-outline h-100" style="border-top: 3px solid #FF6B35 !important;">
            <div class="card-header">
              <h5 class="card-title"><i class="fas fa-bolt" style="color: #FF6B35;"></i> Sprint</h5>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                <tr><td>Total Ujian</td><td class="text-right"><strong>{{ summary.sprint.total_ujian }}</strong></td></tr>
                <tr><td>Rata-rata Skor</td><td class="text-right"><strong class="text-primary">{{ summary.sprint.rata_rata }}</strong></td></tr>
                <tr><td>Skor Tertinggi</td><td class="text-right"><strong class="text-success">{{ summary.sprint.skor_tertinggi }}</strong></td></tr>
                <tr><td>Skor Terendah</td><td class="text-right"><strong class="text-danger">{{ summary.sprint.skor_terendah }}</strong></td></tr>
              </table>
              <div class="mt-2">
                <small class="text-muted">Detail Ujian:</small>
                <ul class="list-unstyled mt-1" style="max-height:150px;overflow-y:auto;">
                  <li v-for="u in summary.sprint.list" :key="u.id" class="mb-1 d-flex justify-content-between">
                    <span class="badge badge-light">{{ u.tanggal }}</span>
                    <span :class="u.skor >= 70 ? 'text-success' : 'text-danger'"><strong>{{ u.skor }}</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Grafik Perbandingan -->
      <div class="card mb-4" v-if="hasData">
        <div class="card-header bg-gradient-primary text-white">
          <h5 class="card-title mb-0"><i class="fas fa-chart-bar"></i> Perbandingan Performa per Program</h5>
        </div>
        <div class="card-body">
          <canvas ref="chartPerbandingan" height="300"></canvas>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authFetch, auth } from "@/libs/hxcore";
import Chart from "chart.js";
import Swal from "sweetalert2";

export default {
  name: "SummaryLengkap",
  data() {
    return {
      info: {},
      summary: {},
      overall: { total_ujian: 0, rata_rata: 0, skor_tertinggi: 0, program_terbaik: '-' },
      chart: null,
    };
  },
  computed: {
    hasData() {
      return this.overall.total_ujian > 0;
    },
  },
  created() {
    const user = auth.user();
    if (user) this.info = user;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      authFetch("/siswa/test/summary_lengkap")
        .then(res => res.json())
        .then(json => {
          if (json.success) {
            const summaryData = json.data.summary || {};
            const overallData = json.data.overall || {};
            this.summary = summaryData.summary || summaryData;
            this.overall = overallData.overall || overallData;
            this.$nextTick(() => this.renderChart());
          }
        });
    },
    renderChart() {
      if (!this.$refs.chartPerbandingan) return;
      const ctx = this.$refs.chartPerbandingan.getContext('2d');
      if (this.chart) this.chart.destroy();

      const tipes = [];
      const rataRata = [];
      const tertinggi = [];
      const terendah = [];

      ['skd', 'polri', 'tpa', 'sprint'].forEach(t => {
        if (this.summary[t] && this.summary[t].total_ujian > 0) {
          tipes.push(t.toUpperCase());
          rataRata.push(this.summary[t].rata_rata);
          tertinggi.push(this.summary[t].skor_tertinggi);
          terendah.push(this.summary[t].skor_terendah);
        }
      });

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: tipes,
          datasets: [
            { label: 'Rata-rata', data: rataRata, backgroundColor: 'rgba(54, 162, 235, 0.7)' },
            { label: 'Tertinggi', data: tertinggi, backgroundColor: 'rgba(75, 192, 192, 0.7)' },
            { label: 'Terendah', data: terendah, backgroundColor: 'rgba(255, 99, 132, 0.7)' },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: { yAxes: [{ ticks: { beginAtZero: true, max: 100 } }] },
        },
      });
    },
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy();
  },
};
</script>

<style scoped>
.info-box { border-radius: 10px; }
.card-outline { border-radius: 12px; }
.card-header { border-radius: 12px 12px 0 0 !important; }
</style>
